const articlesTable = [
  {
    source: 'article_status',
    sortable: true,
    title: 'Status',
    selectable: true,
  },
  {
    source: 'article_title',
    sortable: false,
    title: 'Title',
    selectable: true,
  },
  {
    source: 'article_marketplace_name',
    sortable: true,
    title: 'Marketplace',
    selectable: true,
  },
  {
    source: 'article_post_date',
    sortable: true,
    title: 'Post at',
    selectable: true,
  },
  {
    source: 'article_last_edite',
    sortable: true,
    title: 'Update at',
    selectable: true,
  },
];

export default articlesTable;
